import type { RegionDetail } from '../../../../api/regions';

/** Names the parent so a subregion reads as part of something (BON-425). */
export function regionLevelLabel(detail: RegionDetail): string {
  if (detail.parentId === null) return 'Top-level region';
  return detail.parentName ? `Subregion of ${detail.parentName}` : 'Subregion';
}
